export default () => ({
  tags: [],
  tagsLoading: false,
  tagBeingEdited: {}, // populated using the clearTagBeingEdited mutation by the init boot file
  tagsError: {},
  tagsErrorMessage: false,
  savingTag: false,
});
